import service from '@/middleware'

const fleetApi = {
    /**
     * Datos para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} headers
     * @param {*} enterpriseIds
     */
    async findAll(pageSize, pageNumber, headers, enterpriseIds) {
        const url = pageSize != null && pageNumber != null
            ? `/api/fleet/all?pageSize=${pageSize}&pageNumber=${pageNumber}&headers=${headers}`
            : `/api/fleet/all?headers=${headers}`
        const response = await service.http.post(url, enterpriseIds)
        return response
    },
    /**
     * Total de flotas para el paginador de la tabla del ABM
     * @param {*} enterpriseIds
     */
    async getTotal (enterpriseIds) {
        const result = await service.http.post(`/api/fleet/total`, enterpriseIds)
        return result
    },
    /**
     * Para obtener un flota con el id enviado como param
     * @param {*} fleetId
     */
    async getFleet (fleetId) {
        const result = await service.http.get(`/api/fleet/${fleetId}`)
        return result
    },
    /**
     * Para obtener los flotas con el enterpriseId enviado como parámetro
     * @param {*} enterpriseId
     */
    async getFleetsByEnterpriseId (enterpriseId) {
        const result = await service.http.get(`/api/fleet/by-enterprise/${enterpriseId}`)
        return result
    },
    /**
     * Para validar el nombre de un flota
     * @param {*} name
     */
    async validateFleetName (name) {
        const result = await service.http.get(`/api/fleet/validate-name/${name}`)
        return result
    },
    /**
     * Para crear un nuevo flota
     * @param {*} fleetDto
     * @param {*} thingIds
     */
    async create (fleetDto, thingIds) {
        const result = await service.http.post(`/api/fleet/create`, { fleetDto, thingIds })
        return result
    },
    /**
     * Para actualizar un flota
     * @param {*} fleetDto
     * @param {*} thingIds
     */
    async update (fleetDto, thingIds) {
        const result = await service.http.put(`/api/fleet/update`, { fleetDto, thingIds })
        return result
    },
    /**
     * Para eliminar un flota
     * @param {*} id
     */
    async deleteOne (id) {
        const result = await service.http.delete(`/api/fleet/${id}`)
        return result
    },
    /**
     * Eliminación múltiple
     * @param {*} ids 
     */
    async deleteMany (ids) {
        const result = await service.http.put(`/api/fleet/multiple-delete`, ids)
        return result
    },
    /**
     * Obtener las flotas
     */
    async getAll () {
        const result = await service.http.get(`/api/fleet/all`)
        return result
    },
}

export default fleetApi
